import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section } from './Section';
import type { Testimonio } from '../data/testimonios';
type TestimonialsProps = {
  testimonials: Testimonio[];
  title?: string;
  background?: 'ivory' | 'white';
};
function Stars() {
  return <div className="flex gap-1" aria-label="5 de 5 estrellas" data-id="element-200" data-mp="3b0knxyo4l0sc">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-201" data-mp="36ypqj59bf7ju" data-mpi={i} />)}
    </div>;
}
export function Testimonials({
  testimonials,
  title,
  background = 'white'
}: TestimonialsProps) {
  return <Section tone={background} data-id="element-202" data-mp="2x2w3ut1vtxoc">
      {title && <h2 className="mx-auto max-w-[24ch] text-center font-serif text-[26px] leading-tight sm:text-4xl" data-id="element-203" data-mp="2s2i1nrmyphy8">
          {title}
        </h2>}
      <ul className={`mx-auto grid gap-5 ${testimonials.length === 2 ? 'max-w-[820px] md:grid-cols-2' : 'md:grid-cols-3'} ${title ? 'mt-12' : ''}`} data-id="element-204" data-mp="v7c85aw5tdri">
        {testimonials.map(t => <li key={t.quote} className="card-editorial flex flex-col gap-5 p-7" data-id="element-205" data-mp="m5b4hoxjxuic">
            <Stars data-id="element-206" data-mp="78tryudmm9u7" />
            <blockquote className="flex-1 text-[15px] leading-relaxed text-ink-soft" data-id="element-207" data-mp="79lelfp8wx8c">
              {t.quote}
            </blockquote>
            <footer className="flex items-center gap-3.5 border-t border-gold-line pt-4" data-id="element-208" data-mp="zwfv61ixzcgj">
              {t.photo && <img src={t.photo} alt={`Retrato de ${t.author}`} className="h-12 w-12 shrink-0 rounded-full border border-gold-line object-cover" loading="lazy" data-id="element-209" data-mp="14w2d2o9ptgvo" />}
              <div data-id="element-210" data-mp="v3d1zui2u50v">
                <p className="font-serif text-base" data-id="element-211" data-mp="1ivk0p0b9yo3g">{t.author}</p>
                {(t.role || t.city) && <p className="mt-0.5 text-xs uppercase tracking-[0.12em] text-ink-muted" data-id="element-212" data-mp="1nmjwu3ckl24w">
                    {[t.role, t.city].filter(Boolean).join(' · ')}
                  </p>}
              </div>
            </footer>
          </li>)}
      </ul>
    </Section>;
}